<template>
    <div class="p-2" style="width:250px">
      <form-label>{{$t('GradeControl.Timesheet.Employee')}}</form-label>
      <vs-checkbox v-model="isContractual" class="mb-2">{{$t('GradeControl.Contractual')}}</vs-checkbox>
      <v-select
        wid
        label="fullName"
        :options="employees"
        :reduce="employee => employee.code"
        v-model="employeeCode"
        @input="setSelected"
        class="w-full"
        name="employeeCode"
      />
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { FormLabel } from "./../../../../shared/components";

export default {
  name: 'EmployeesCellEditor',
  data() {
    return {
      employeeCode: null,
      isContractual: false
    }
  },
  computed: {
    employees() {
      return this.params.context.componentParent.employees.filter(e => e.isContractual === this.isContractual);
    }
  },
  watch: {
    isContractual() {
      const selectedEmployee = this.params.context.componentParent.employees.find(e => e.code === this.employeeCode && e.isContractual === this.isContractual);
      
      if (!selectedEmployee) {
        this.employeeCode = null;
      }
    } 
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.isContractual = this.params.value.isContractual;
    this.employeeCode = this.params.value.employeeCode;
  },
  methods: {
    getValue() {
      const employeeCode = this.employeeCode;
      const isContractual = this.isContractual;
      return {
        employeeCode,
        isContractual
      };
    },
    setEmployeeCode(code) {
      this.employeeCode  = code;
    },
    isPopup() {
      return true;
    },
    setSelected(code) {
      this.setEmployeeCode(code);
      this.params.api.stopEditing();
    }
  }
}
</script>
